import { render } from "./basecheckbox.vue?vue&type=template&id=31e0a8e9"
import script from "./basecheckbox.vue?vue&type=script&lang=js"
export * from "./basecheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__